import { FieldValues, FormProvider, FormProviderProps } from "react-hook-form"

interface IFormWrapperProps<T extends object = FieldValues> extends Omit<React.FormHTMLAttributes<HTMLFormElement>, "onSubmit"> {
  methods: Omit<FormProviderProps<T>, "children">
  onSubmit: (data: any) => void
}
export const FormWrapper = <T extends object = FieldValues>({ methods, onSubmit, ...props }: IFormWrapperProps<T>) => {
  return (
    <FormProvider {...methods}>
      <form noValidate autoComplete="off" {...props} onSubmit={methods.handleSubmit(onSubmit)} />
    </FormProvider>
  )
}
